import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';

import * as AccountActions from '../account/account.actions';
import { selectPatient } from '../patient/patient.selectors';
import * as RecordActions from './record.actions';
import { Record } from 'src/app/core/models/record.model';
import { of } from 'rxjs';


@Injectable()
export class RecordEffects {


  loadRecords$ = createEffect(() => {
    return this.store.select(selectPatient).pipe(
      map(patient => patient?.id),
      filter(patientId => !!patientId),
      distinctUntilChanged(),
      tap(() => this.store.dispatch(RecordActions.clearRecords())),
      switchMap(patientId => {
        return this.afs.collection<Record>('records', ref => ref.where('patientId', '==', patientId).orderBy('createdAt', 'desc'))
          .snapshotChanges();
      }),
      switchMap(actions => {
        const addActions = actions.filter(action => action.type === 'added');
        const loadAction = RecordActions.addRecords({
          records: addActions.map(action => {
            return {
              ...action.payload.doc.data(),
              id: action.payload.doc.id,
            };
          })
        });
        const otherActions = actions.filter(action => action.type !== 'added').map(action => {
          switch (action.type) {
            case 'modified':
              return RecordActions.updateRecord({
                record: {
                  id: action.payload.doc.id,
                  changes: {
                    ...action.payload.doc.data()
                  }
                }
              });
            case 'removed':
              return RecordActions.deleteRecord({
                id: action.payload.doc.id
              });
            default:
              break;
          }
        });
        const allActions = [
          loadAction,
          ...otherActions
        ];
        return of(...allActions);
      })
    );
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AccountActions.logout),
      map(() => RecordActions.clearRecords())
    );
  });



  constructor(
    private actions$: Actions,
    private store: Store,
    private afs: AngularFirestore,
  ) {}

}
